import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  fetchChannelsPage,
  searchChannelsApi,
  createChannelApi,
  updateChannelApi,
  deleteChannelApi,
  testChannelApi,
  updateChannelBalanceApi,
  batchDeleteChannelsApi,
  testAllChannelsApi,
  updateAllChannelsBalanceApi,
  fixChannelCapabilitiesApi,
  deleteDisabledChannelsApi,
  type ChannelListParams,
  type SearchChannelsParams,
  type ChannelListResponse,
} from '@/api/channels'

export function useChannels(params?: ChannelListParams) {
  return useQuery({
    queryKey: ['channels', params],
    queryFn: () => fetchChannelsPage(params),
  })
}

export function useSearchChannels(params: SearchChannelsParams, enabled: boolean) {
  return useQuery({
    queryKey: ['channels-search', params],
    queryFn: () => searchChannelsApi(params),
    enabled,
  })
}

export type { ChannelListParams, ChannelListResponse, SearchChannelsParams }

export function useCreateChannel() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: createChannelApi,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['channels'] }),
  })
}

export function useUpdateChannel() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: updateChannelApi,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['channels'] }),
  })
}

export function useDeleteChannel() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: deleteChannelApi,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['channels'] }),
  })
}

export function useBatchDeleteChannels() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (ids: number[]) => batchDeleteChannelsApi(ids),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['channels'] }),
  })
}

export {
  testChannelApi,
  updateChannelBalanceApi,
  testAllChannelsApi,
  updateAllChannelsBalanceApi,
  fixChannelCapabilitiesApi,
  deleteDisabledChannelsApi,
}
